import React, { memo } from 'react'

import Tag from './Tag'
import Img from './Img'

import { getFirstArrayElement } from '../utils/getFirstArrayElement'

const PostPreview = ({ data, className }) => {
  const postData = data.data
  const category = getFirstArrayElement(
    postData?.article_categories,
  )?.article_category
  const author = postData?.article_author?.document?.data
  return (
    <div className={`${className} post-preview`}>
      <Img
        image={postData?.image?.gatsbyImageData}
        alt={postData?.image?.alt}
        className="post-image"
      />
      {category && <Tag text={category} type={category} />}
      <p className="post-title">{postData?.title.text}</p>
      <div className="post-info">
        <div className="author-box">
          <Img
            image={author?.photo?.gatsbyImageData}
            alt={author?.photo?.alt}
            className="author-image"
          />
          <p className="p-14 author-name">{author?.name}</p>
        </div>
        <span className="post-date">{postData?.publish_date}</span>
      </div>
    </div>
  )
}

export default memo(PostPreview)
